enum BreakPoints {
	TAPOK_319 = 319, // до 375

	MOBILE_767 = 767,
	MOBILE_768 = 768,

	MOBILE_979 = 979,
	MOBILE_980 = 980,

	TABLET_1023 = 1023,
	TABLET_1024 = 1024,

	PC_1279 = 1279,
	PC_1280 = 1280,

	LARGE_1439 = 1439,
	LARGE_1440 = 1440,

	FHD_1919 = 1919,
	FHD_1920 = 1920,

	DESKTOPS2 = "1440px",
	DESKTOPS = "1365.98px",
	DESKTOPS_SMALL = "1280px",
	DESKTOPS_OLD = "1024px",
	DESKTOPS_OLD_BORDER = "1025px",

	TABLETS = "767.98px",
	TABLETS2 = "779.98px",
	PHONES = "319.98px",
	PHONES2 = "480px",

	NOTEBOOK = "980px",
	NOTEBOOK_BORDER = "981px",
	NOTEBOOK_2 = "1439px",
	NOTEBOOK2 = "979.98px",
	NOTEBOOK3 = "980.98px",
}

export default BreakPoints;
